function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
// @ts-nocheck
import * as React from 'react';
import { filterDataProps } from '../../utils/FilterDataProps';
import { CoreDropdown } from '../CoreDropdown';
import { OptionFactory } from '../CoreDropdownOption';
import { CoreInput } from '../CoreInput';
import { classes, st } from './CoreInputWithOptions.st.css';
export const DataHooks = {
    input: 'input',
    emptyState: 'input-with-options-empty-state'
};
var _React_PureComponent;
/**
 * InputWithOptions
 */ export class CoreInputWithOptions extends (_React_PureComponent = React.PureComponent) {
    open() {
        // Using getInstance() is here because closeOutside HOC
        this.dropDownRef && this.dropDownRef.open();
    }
    close() {
        this.dropDownRef && this.dropDownRef.close();
    }
    _filterOptions() {
        const { highlightMatches, inputProps, options, filterPredicate, emptyStateMessage, emptyStateStyle } = this.props;
        if (!inputProps.value || !this.isEditing) {
            return options;
        }
        const filteredOptions = options.filter((option)=>!option.isSelectable && option.value || option.isSelectable && option.value && filterPredicate(inputProps.value, option.value));
        if (!highlightMatches) {
            return filteredOptions;
        }
        if (emptyStateMessage && filteredOptions.length === 0) {
            return [
                OptionFactory.create({
                    render: ()=>/*#__PURE__*/ React.createElement("div", {
                            "data-hook": DataHooks.emptyState,
                            style: emptyStateStyle || {}
                        }, emptyStateMessage),
                    isDisabled: true
                })
            ];
        }
        return filteredOptions.map((option)=>option.isSelectable && option.value ? OptionFactory.createHighlighted(option, inputProps.value) : option);
    }
    render() {
        const { placement, openTrigger, initialSelectedIds, onInitialSelectedOptionsSet, multi, fixedFooter, fixedHeader, timeout, onDeselect, inputProps, forceContentElementVisibility, style: inlineStyles, id, allowReselect, flip, fixed, moveBy, optionsContainerZIndex, appendTo, className, dynamicWidth } = this.props;
        const contentId = id ? `${id}-content` : null;
        const filteredOptions = this._filterOptions();
        const firstOption = filteredOptions.length ? filteredOptions[0].id : null;
        return /*#__PURE__*/ React.createElement(CoreDropdown, {
            className: st(classes.root, className),
            placement: placement,
            openTrigger: openTrigger,
            disabled: inputProps.disabled,
            onSelect: this._onSelect,
            onOptionHover: this.onOptionHover,
            fixedFooter: fixedFooter,
            fixedHeader: fixedHeader,
            onDeselect: onDeselect,
            initialSelectedIds: initialSelectedIds,
            onInitialSelectedOptionsSet: onInitialSelectedOptionsSet,
            options: this._filterOptions(),
            timeout: timeout,
            multi: multi,
            forceContentElementVisibility: forceContentElementVisibility,
            style: inlineStyles,
            ref: this._setDropDownRef,
            allowReselect: allowReselect,
            flip: flip,
            fixed: fixed,
            moveBy: moveBy,
            onContentMouseDown: this._onContentMouseDown,
            contentId: contentId,
            onExpandedChange: this.changeExpanded,
            optionsContainerZIndex: optionsContainerZIndex,
            appendTo: appendTo,
            dynamicWidth: dynamicWidth,
            contentRole: "listbox",
            focusOnOption: firstOption,
            dropdownA11yFixes: true,
            ...filterDataProps(this.props)
        }, /*#__PURE__*/ React.createElement(CoreInput, {
            "data-hook": DataHooks.input,
            ...inputProps,
            role: "combobox",
            "aria-autocomplete": "both",
            "aria-controls": contentId,
            "aria-expanded": this.state.ariaExpanded,
            "aria-activedescendant": this.state.ariaActivedescendant,
            onKeyDown: this._onKeyDown,
            onFocus: this._onFocus,
            onBlur: this._onBlur,
            className: classes.inputComponent
        }));
    }
    constructor(...args){
        super(...args), _define_property(this, "dropDownRef", null), _define_property(this, "isEditing", false), _define_property(this, "state", {
            ariaActivedescendant: null,
            ariaExpanded: false
        }), _define_property(this, "_setDropDownRef", (ref)=>{
            this.dropDownRef = ref;
        }), _define_property(this, "changeExpanded", (isExpanded)=>{
            this.setState({
                ariaExpanded: isExpanded
            });
        }), _define_property(this, "onOptionHover", (option)=>{
            const ariaActivedescendant = option ? option._DOMid : null;
            this.setState({
                ariaActivedescendant
            });
        }), _define_property(this, "_onSelect", (option)=>{
            this.isEditing = false;
            const { onSelect, onManualInput, inputProps } = this.props;
            if (option) {
                onSelect(option);
            } else {
                onManualInput(inputProps.value);
            }
            this.setState({
                ariaActivedescendant: null
            });
        }), _define_property(this, "_onKeyDown", (event)=>{
            if (!event.key.startsWith('Arrow')) {
                this.isEditing = true;
                this.setState({
                    ariaActivedescendant: null
                });
            }
            const { onKeyDown } = this.props.inputProps;
            onKeyDown && onKeyDown(event);
        }), _define_property(this, "_onFocus", (event)=>{
            this.isEditing = false;
            const { onFocus } = this.props.inputProps;
            onFocus && onFocus(event);
        }), _define_property(this, "_onBlur", (event)=>{
            if (this.isEditing) {
                this._onSelect(null);
            }
            const { onBlur } = this.props.inputProps;
            onBlur && onBlur(event);
        }), _define_property(this, "_onContentMouseDown", (e)=>{
            const { onContentMouseDown } = this.props;
            this.isEditing = false;
            onContentMouseDown && onContentMouseDown(e);
        });
    }
}
_define_property(CoreInputWithOptions, "displayName", 'CoreInputWithOptions');
_define_property(CoreInputWithOptions, "defaultProps", {
    openTrigger: 'click',
    placement: 'bottom-start',
    multi: false,
    initialSelectedIds: [],
    highlightMatches: true,
    onSelect: ()=>null,
    onDeselect: ()=>null,
    onManualInput: ()=>null,
    onInitialSelectedOptionsSet: ()=>null,
    filterPredicate: (inputValue, optionValue)=>optionValue.toLowerCase().includes(inputValue.toLowerCase())
});
_define_property(CoreInputWithOptions, "bypassDefaultPropsTypecheck", void 0);

//# sourceMappingURL=CoreInputWithOptions.js.map